import comHome from '../components/page/Home'
import comDashboard from '../components/page/Dashboard'
import comOrganisation from '../components/page/Organisation'
import comOrganisationUser from '../components/page/OrganisationUser'
import comHospitals from '../components/page/Hospitals'
import comHospital from '../components/page/Hospital'
import comUsers from '../components/page/Users'
import comUser from '../components/page/User'
import comPatients from '../components/page/Patients'
import comPatient from '../components/page/Patient'
import comDomain from '../components/page/Domain'
import comLogout from '../components/page/Logout'
import comTerms from '../components/page/Terms'
import comPrivacy from '../components/page/Privacy'
import comCookies from '../components/page/Cookies'

export default [
    {
        path: '/',
        name: 'Home',
        component: comHome
    },
    {
        path: '/terms',
        name: 'Terms',
        component: comTerms
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: comPrivacy
    },
    {
        path: '/cookies',
        name: 'Cookies',
        component: comCookies
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: comDashboard
    },
    {
        path: '/organisation/:id',
        name: 'Organisation',
        component: comOrganisation
    },
    {
        path: '/organisation/:organisation/user/:id',
        name: 'Organisation.User',
        component: comOrganisationUser
    },
    {
        path: '/hospitals',
        name: 'Hospitals',
        component: comHospitals
    },
    {
        path: '/hospitals/:id',
        name: 'Hospital',
        component: comHospital
    },
    {
        path: '/users',
        name: 'Users',
        component: comUsers
    },
    {
        path: '/users/:id',
        name: 'User',
        component: comUser
    },
    {
        path: '/users',
        name: 'Users',
        component: comUsers
    },
    {
        path: '/patients/:id',
        name: 'Patient',
        component: comPatient
    },
    {
        path: '/patients',
        name: 'Patients',
        component: comPatients
    },
    {
        path: '/domain/:domain/:patient',
        name: 'Domain',
        component: comDomain
    },
    {
        path: '/logout',
        name: 'Logout',
        component: comLogout
    }
]